module.exports = __webpack_public_path__ + "static/media/bg-image-17.1f1167d3.jpg";